import { useReducer } from 'react';
import { newUserReducer } from './newUserReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  NewUserDispatchContext,
  NewUserStateContext,
} from './useNewUserContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface INewUserProviderProps {
  children: any;
  value?: IValue;
}

export function NewUserProvider({
  children,
  value = { initialState: defaultContextValues, reducer: newUserReducer },
}: INewUserProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <NewUserStateContext.Provider value={state}>
      <NewUserDispatchContext.Provider value={dispatch}>{children}</NewUserDispatchContext.Provider>
    </NewUserStateContext.Provider>
  );
}
